// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Anchor_anchor___CNsb","anchorText":"Anchor_anchorText__sKpRJ"};